/**
 * MIRAK video section: a single always-visible play/pause button — no
 * autoplay, no separate mute control (sound is fixed per the section's
 * Sound setting). Pausing when the section scrolls out of view keeps a
 * forgotten playing video from running (and making noise) off-screen.
 */

function initVideoPlayer(player) {
  const video = player.querySelector('video');
  const toggle = player.querySelector('[data-mirak-video-toggle]');
  if (!video || !toggle) return;

  const syncButton = () => {
    const isPlaying = !video.paused && !video.ended;
    toggle.classList.toggle('is-playing', isPlaying);
    toggle.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
  };

  toggle.addEventListener('click', () => {
    if (video.paused || video.ended) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  });

  video.addEventListener('play', syncButton);
  video.addEventListener('pause', syncButton);
  video.addEventListener('ended', syncButton);

  const visibilityObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && !video.paused) video.pause();
      });
    },
    { threshold: 0 },
  );
  visibilityObserver.observe(player);

  syncButton();
}

document.querySelectorAll('[data-mirak-video-player]').forEach(initVideoPlayer);
